export type ImageValidationMessages = {
  unsupportedFileFormat: string;
  fileTooLarge: string;
  invalidFileName: string;
  imageDimensionsExceeded: string;

  // Photos
  dropPhoto: string;
  imageButton: string;
  noImageMessage: string;
  noImageSelected: string;

  // Dialog messages
  confirmDeleteTitle: string;
  confirmDeleteDescription: string;
};

export const IMAGE_VALIDATION_MESSAGES: ImageValidationMessages = {
  unsupportedFileFormat: "Formato de arquivo não suportado. Apenas JPG, JPEG e PNG são permitidos.",
  fileTooLarge: "O arquivo é muito grande. O tamanho máximo permitido é de 2 MB.",
  invalidFileName: "Nome de arquivo inválido. Não use espaços, traços ou caracteres especiais.",
  imageDimensionsExceeded: "As dimensões da imagem excedem o limite de 2000x2000 pixels.",

  // Photos
  dropPhoto: "Arraste as imagens aqui, ou clique para selecionar",
  imageButton: "Selecionar imagem",
  noImageMessage: "Nenhuma imagem disponível. Adicione uma imagem.",
  noImageSelected: "Adicione até 10 imagens.",

  // Dialog messages
  confirmDeleteTitle: "Confirmar exclusão",
  confirmDeleteDescription: "Tem certeza de que deseja excluir esta imagem?",
};
